<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RefReward" v-model="rewardList" :drawer="true" :single="true" />
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="砍一刀活动" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardInviteHelpEdit:import'"
                  :export-p="'config:rewardInviteHelpEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="积分配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pointId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="积分数量" width="150" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="积分数量" />
                </template>
              </el-table-column>
              <el-table-column label="最大帮助次数" width="150" align="center">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.maxHelpTime" :controls="false" :min="0" placeholder="最大帮助次数" />
                </template>
              </el-table-column>
              <el-table-column label="帮助奖励" align="center">
                <template slot-scope="scope">
                  <div style="width: 100%;height: 100%;min-height: 1.5rem" @click="handleEditReward(scope.row.helpReward)">
                    <i class="el-icon-edit-outline" style="margin-right: 0.5rem" />{{ handleShowReward(scope.row.helpReward) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="奖励" align="center">
                <template slot-scope="scope">
                  <div style="width: 100%;height: 100%;min-height: 1.5rem" @click="handleEditReward(scope.row.reward)">
                    <i class="el-icon-edit-outline" style="margin-right: 0.5rem" />{{ handleShowReward(scope.row.reward) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardInviteHelpEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardInviteHelpEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardInviteHelpEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'InviteHelp',
  components: { CommonExcel, Reward },
  data() {
    return {
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'invite_help',
      rewardConf: [],
      rewardList: [],
      isOnline: 0
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], num: 0, pointId: 0, maxHelpTime: 0, reward: [], helpReward: [] })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.baseList = res.data.list[0].reward_conf
          if (!this.baseList) {
            this.baseList = []
          }
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[4], proId: this.list[2], superProId: this.list[3], goodsId: this.list[5] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '砍一刀配置'
      const hearer = []
      const excelData = []
      const name = ['砍一刀配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, proId: this.list[2], superProId: this.list[3], rewardId: this.list[4], goodsId: this.list[5] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, pointId: '积分配置', num: '积分数量', maxHelpTime: '最大帮助次数', helpReward: { name: '帮助奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}, reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    handleEditReward(reward) {
      this.rewardList = reward
      this.$refs.RefReward.handleShowDrawer()
    },
    handleShowReward(reward) {
      return this.$refs.RefReward.handleShowReward(reward)
    }
  }
}
</script>

<style scoped>
</style>
